<template>
  <div class="manualOperation">
    <div class="wrapHeader">
      <el-form :inline="true" class="demo-form-inline" :model="selectCirWare">
        <el-form-item label="仓房选择">
          <el-select v-model="selectCirWare.wareId" @change='wareIdChange' placeholder="仓房选择">
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' style='min-height:887px'>
      <div class="wareModel" style='min-height:887px'>
        <img :src='wareModel'>
        <el-button type="primary" class='commonBtn addFan' @click='allStart'>一键开启</el-button>
        <el-button type="danger" class='commonBtn saveFanModel' @click='allStop'>一键停止</el-button>
        <el-button :type="btnType" class='commonBtn switchModel' @click='switchModel'>{{orientation}}</el-button>
        <el-card class="tempInfo" :body-style="{ padding:'0px'}" :style="`height:${showthListSize}px`" v-if="thList.length>0">
          <div class="infoHead" @click="showthList"><span>仓内温湿度信息</span><i :class="icon1"></i></div>
          <div class="tempList">
            <div class="tempItem" v-for='item in thList' :key='item.nhlThId'>
              <div class="itemName">通道{{item.sort}}：</div>
              <div class="temp">温度：{{item.temp}} ℃</div>
              <div class="humidity">湿度：{{item.hum}} RH%</div>
            </div>
          </div> 
        </el-card>
        <el-card class="tempInfo" :body-style="{ padding:'0px'}" :style="`height:${showoutThListSize}px;left:${thList.length==0?15:365}px`" v-if="outThList.length>0">
          <div class="infoHead" @click="showoutThList"><span>通风口温湿度信息</span><i :class="icon2"></i></div>
          <div class="tempList">
            <div class="tempItem" v-for='item in outThList' :key='item.nhlThId'>
              <div class="itemName">通道{{item.sort}}：</div>
              <div class="temp">温度：{{item.temp}} ℃</div>
              <div class="humidity">湿度：{{item.hum}} RH%</div>
            </div>
          </div> 
        </el-card>
        <div class='fanList' v-if='fanList.length>0&&orientation=="正面"'>
          <div 
            :class='["fanItem",fanStyle]' 
            :style="`top:${item.fanY}px;left:${item.fanX}px;background-image:url(${item.fanStatus==1?imgSrc2:imgSrc1})`" 
            v-for="(item,index) in fanList" :key='index'
            @click='setMacStatus(item.nhlFanId,item.fanNo)'>
            <div>
              <span class="fanName">{{item.fanName}}</span>
            </div>
          </div>
        </div>
        <div class="fanList" v-else>
          <div 
            :class='["fanItem",fanStyle]' 
            :style="`top:${item.fanY}px;left:${item.fanX}px`" 
            v-for="(item,index) in fanAfterList" 
            :key='index'
            @click="setMacStatus(item.nhlFanId,item.fanNo)">
            <div><span class="fanName">{{item.fanName}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="setMacView"
      width="30%"
      :custom-class='"dialogLoading"'
      >
      <span>{{info}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setMacView = false">取 消</el-button>
        <el-button :type="btnStatus" @click="setStatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
import wareModel1 from '../../assets/cir/wareModel1.jpg'
import imgSrc1 from '../../assets/cir/fan.png'
import imgSrc2 from '../../assets/cir/fan.gif'
import createSocket from '../../webSocket.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      selectCirWare:{
        wareId:''
      },
      wareList:[],
      btnType:'primary',
      orientation:'正面',
      wareModel:wareModel1,
      fanList:[],
      fanAfterList:[],
      fanStyle:'fanItem1',
      setMacView:false,
      info:'',
      btnStatus:'primary',
      btnInfo:'开启',
      setInfo:{},
      fanNo:0,
      loading:false,
      allFanId:[],
      imgSrc1:imgSrc1,
      imgSrc2:imgSrc2,
      showthListSize:35,
      showoutThListSize:35,
      icon1:'el-icon-d-arrow-right',
      icon2:'el-icon-d-arrow-right',
      thList:[],
      outThList:[],
      ws:null
    }
  },
  created(){
    this.getWareList();
  },
  destroyed(){
    this.ws.close()
  },
  methods:{
    socket(){
      this.ws=createSocket('/websocket/nhlFanStatus')
      this.ws.onmessage=this.wsMessage;
    },
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data;
          this.selectCirWare={
            wareId:res.data[0].wareId
          };
          this.getFanList();
        }
      })
    },
    wareIdChange(){
      this.getFanList();
    },
    getFanList(){
      if(!this.ws||this.ws.readyState==3){
        this.socket()
        this.sendId()
      }else{
        this.sendId()
      }
      axios.get(`/system/fan/selectNhlFanByWareId/${this.selectCirWare.wareId}`).then(res=>{
        if(res){
          let arr=[]
          this.wareModel=res.data.picNo?require('../../assets/cir/wareModel'+res.data.picNo+'.jpg'):wareModel1;
          this.fanList=res.data.fanList;
          this.fanAfterList=res.data.fanAfterList;
          this.setInfo.serId=res.data.serId;
          this.fanStyle=res.data.picNo?'fanItem'+res.data.picNo:'fanItem1';
          this.thList=res.data.thList;
          this.outThList=res.data.outThList;
          res.data.fanList.forEach(item=>{
            arr.push(item.nhlFanId)
          })
          res.data.fanAfterList.forEach(item=>{
            arr.push(item.nhlFanId)
          })
          this.allFanId=arr;
        }
      })
    },
    sendId(){
      if(this.ws.readyState===1){
        this.ws.send(this.selectCirWare.wareId);
      }else{
        setTimeout(()=>{
          this.sendId()
        },500)
      }
    },
    wsMessage(res){
      let data=JSON.parse(res.data);
      this.fanList=data.fanList;
      this.fanAfterList=data.fanAfterList;
      this.thList=data.thList;
      this.outThList=data.outThList;
    },
    switchModel(){
      if(this.btnType=='primary'){
        this.btnType='info'
        this.orientation='反面'
      }else{
        this.btnType='primary'
        this.orientation='正面'
      }
    },
    setMacStatus(serId,fanNo){
      this.fanNo=fanNo;
      let arr=this.orientation=='正面'?this.fanList:this.fanAfterList;
      arr.forEach(item=>{
        if(item.nhlFanId==serId){
          if(item.fanStatus==1){
            this.info=item.fanName+'正在运行中，是否停止？'
            this.btnStatus='danger'
            this.btnInfo='停止'
          }else{
            this.info=item.fanName+'正在待机中，是否开启？'
            this.btnStatus='primary'
            this.btnInfo='开启'
          }
        }
      })
      this.setMacView=true
    },
    setLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialogLoading')
      })
    },
    setStatus(){
      this.setInfo.fanNoList=[this.fanNo]
      this.setInfo.fanStatus=this.btnStatus=='primary'?1:0;
      this.setLoading()
      this.setFanStatus(1);
      this.ws.close()
    },
    allStart(){
      this.setInfo.fanNoList=this.allFanId;
      this.setInfo.fanStatus=1;
      this.setFanStatus(0);
    },
    allStop(){
      this.setInfo.fanNoList=this.allFanId;
      this.setInfo.fanStatus=0;
      this.setFanStatus(0)
    },
    setFanStatus(flag){
      axios.post('/system/fan/control',this.setInfo).then(res=>{
        if(flag){
          this.loading.close();
          this.socket()
          this.sendId()
        }
        if(res){
          this.$message({
            type: 'success',
            message: '设置成功!',
            duration:1000
          });
          this.setMacView=false
        }
      })
    },
    showthList(){
      if(this.showthListSize==35){
        this.icon1='el-icon-d-arrow-left';
        this.showthListSize=155
      }else{
        this.icon1='el-icon-d-arrow-right';
        this.showthListSize=35
      }
    },
    showoutThList(){
      if(this.showoutThListSize==35){
        this.icon2='el-icon-d-arrow-left';
        this.showoutThListSize=405
      }else{
        this.icon2='el-icon-d-arrow-right';
        this.showoutThListSize=35
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.manualOperation{
  .wareModel{
    overflow: hidden;
    position: relative;
    width: 1690px;
    img{
      width: 1690px;
      height: 887px;
      position: absolute;
      top:0;
    }
    .switchModel{
      right: 15px;
    }
    .saveFanModel{
      right: 150px;
    }
    .addFan{
      right:285px;
    }
    .tempInfo{
      position: absolute;
      left: 15px;
      top: 15px;
      width:335px;
      font-size: 14px;
      background-color: rgba(255,255,255,0.45);
      padding: 10px;
      box-sizing: border-box;
      z-index: 102;
      .infoHead{
        font-size:16px;
        font-weight: 600;
        font-family: '楷体';
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        border-bottom: 1px solid rgb(189, 187, 187);
      }
      .tempList{
        padding: 3px;
        .tempItem{
          display: flex;
          padding: 2px;
          .itemName{
            width:70px;
            text-align: end;
            padding-right: 10px;
            box-sizing: border-box
          }
          .temp,.humidity{
            width: 110px;
            white-space: nowrap
          }
        }
      }
    }
    .fanList{
      position: absolute;
      z-index: 100;
      top:0px;
      left:0px;
      height:887px;
      width: 1690px;
      .fanItem{
        background-image: url('../../assets/cir/fan.png');
        background-size: cover;
        position: absolute;
        cursor: pointer;
        .fanName{
          position: absolute;
          left: 20px;
          font-size: 12px;
          padding: 5px;
          background: white;
          white-space: nowrap
        }
      }
      .fanItem1{
        height: 250px;
        width:80.43px;
        .fanName{
          top: 75px;
        }
      }
      .fanItem2{
        height: 207px;
        width: 66px;
        .fanName{
          top: 60px;
        }
      }
      .fanItem>div{
        height: 100%;
        width: 100%;
        position: relative;
      }
    }
  }
}
</style>
